import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvoiceitemEditDialogV2Component } from './invoiceitem-edit-dialog-v2.component';
import {CustomMaterialModule} from '@sk/custom-material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DefaultCurrencyPipeModule } from 'shared/pipes/defaultCurrencyPipe/defaultCurrencyPipe.module';

@NgModule({
  declarations: [ InvoiceitemEditDialogV2Component ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomMaterialModule,
    FlexLayoutModule,
    RouterModule,
    DefaultCurrencyPipeModule
  ],
  providers: [],
  exports: [ InvoiceitemEditDialogV2Component ]
})
export class InvoiceItemEditDialogV2Module {
}
